import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { TopNav } from '../shared/TopNav';
import { MainMenuPanel } from '../Panels/MainMenuPanel';
export function HomeMode() {
  const [showMenu, setShowMenu] = useState(false);
  const [cameraDirection] = useState<'N' | 'S' | 'E' | 'W' | 'NE' | 'NW' | 'SE' | 'SW'>('N');
  return <>
      <TopNav onMenuClick={() => setShowMenu(true)} cameraDirection={cameraDirection} data-id="element-671" />

      {/* Main Menu Panel */}
      <MainMenuPanel isOpen={showMenu} onClose={() => setShowMenu(false)} onOpenControls={() => console.log('Open Controls')} onOpenMediaGallery={() => console.log('Open Media Gallery')} onOpenSettings={() => console.log('Open Settings')} data-id="element-672" />

      <div className="absolute inset-0 flex items-end justify-center pb-32 pointer-events-none" data-id="element-673">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center max-w-3xl px-8" data-id="element-674">
          {/* Translucent background with gradient */}
          <div className="relative" data-id="element-675">
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/40 to-transparent backdrop-blur-sm rounded-2xl -m-8" data-id="element-676" />

            <div className="relative z-10 py-8" data-id="element-677">
              <h1 className="text-5xl font-light text-white mb-3 drop-shadow-lg" data-id="element-678">
                Welcome to{' '}
                <span className="font-bold text-cyan-400" data-id="element-679">
                  Evergreen Heights
                </span>
              </h1>
              <p className="text-lg text-white/90 leading-relaxed mb-2 drop-shadow-md" data-id="element-680">
                Explore a modern community designed for sustainable living.
              </p>
              <p className="text-base text-white/80 drop-shadow-md" data-id="element-681">
                Select a mode on the left to begin your journey.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </>;
}